export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`])\S{8,99}$/;
export const URL_PATTERN = /^(https?:\/\/)?(www\.)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i;
export const CODECOMMIT_URL_PATTERN =
  /^https:\/\/git-codecommit\.[a-z0-9-]+\.amazonaws\.com\/v1\/repos\/[a-zA-Z0-9-]+$/;
// AWS S3 bucket naming rules: 3-63 chars of lowercase letters, digits, dots and hyphens,
// starting/ending with a letter or digit, no adjacent dots, not formatted as an IP address.
export const S3_BUCKET_NAME_PATTERN = /^(?!(\d{1,3}\.){3}\d{1,3}$)(?!.*\.\.)[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/;
